import { compareTime } from "../date/compareTime.js";
function isFullDay(start, end) {
  const startDate = /* @__PURE__ */ new Date();
  startDate.setUTCHours(0, 0, 0);
  const endDate = /* @__PURE__ */ new Date();
  endDate.setUTCHours(23, 59, 59);
  return compareTime(start, startDate) === 0 && compareTime(end, endDate) === 0;
}
export {
  isFullDay
};
